export const ENVIRONMENT_LIST = [
  {
    label: "AWS",
    field: "aws",
    value: 0,
    color: "#31C197",
  },
  {
    label: "GCP",
    field: "gcp",
    value: 0,
    color: "#EB5757",
  },
  {
    label: "Azure",
    field: "azure",
    value: 0,
    color: "#2F80ED",
  },
  {
    label: "Other",
    field: "other",
    value: 0,
    color: "orange",
  },
  {
    label: "On Prem",
    field: "onPrem",
    value: 0,
    color: "pink",
  },
];
